import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRODUCT_ITEMS } from "@/lib/salesData";

/* ValueRecapSection — Resumo dos itens inclusos com total de valor e CTA */
const totalValue = 576;
const price = 77.9;
const discountPercent = Math.round(((totalValue - price) / totalValue) * 100);

export function ValueRecapSection() {
  return (
    <section className="py-16 sm:py-24 bg-card/30">
      <div className="container max-w-3xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-8 sm:mb-10"
        >
          <span className="text-accent text-xs font-semibold uppercase tracking-widest mb-3 block">
            O que você leva
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">
            Tudo incluso no seu acesso
          </h2>
        </motion.div>

        <div className="bg-card border border-border rounded-3xl overflow-hidden shadow-xl mb-6">
          {/* Itens */}
          <div className="divide-y divide-border">
            {PRODUCT_ITEMS.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.06 }}
                className="flex items-center justify-between px-5 sm:px-7 py-3.5 sm:py-4 hover:bg-accent/5 transition-colors"
              >
                <div className="flex items-center gap-2.5 sm:gap-3">
                  <span className="text-accent font-bold text-xs w-5 text-center font-mono shrink-0">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>
                  <span className="text-foreground text-xs sm:text-sm">{item.title}</span>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-muted-foreground text-xs line-through hidden sm:inline">
                    {item.value}
                  </span>
                  <span className="text-accent text-xs font-bold font-mono sm:hidden">
                    {item.value}
                  </span>
                  <span className="hidden sm:inline text-xs font-semibold text-accent bg-accent/10 px-2 py-0.5 rounded-full">
                    Incluso
                  </span>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Totais */}
          <div className="bg-background/50 border-t border-border px-5 sm:px-7 py-5">
            <div className="flex justify-between items-center mb-2">
              <span className="text-muted-foreground text-xs sm:text-sm">Valor total separado:</span>
              <span className="text-muted-foreground line-through font-mono text-xs sm:text-sm">
                R$ {totalValue.toFixed(2).replace(".", ",")}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <span className="text-foreground font-bold text-sm sm:text-base">Seu investimento hoje:</span>
                <span className="bg-destructive/20 text-destructive text-xs font-bold px-2 py-0.5 rounded-full">
                  {discountPercent}% OFF
                </span>
              </div>
              <span className="text-accent font-extrabold text-xl sm:text-2xl font-mono">
                R$ {price.toFixed(2).replace(".", ",")}
              </span>
            </div>
          </div>
        </div>

        {/* CTA nativo — sem framer-motion wrapper no <a> para evitar conflito */}
        <div className="w-full">
          <a
            href="https://pay.kiwify.com.br/bGcYJms"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-accent hover:bg-accent/90 text-accent-foreground text-lg sm:text-xl py-4 sm:py-5 rounded-2xl font-bold shadow-lg flex items-center justify-center gap-3 cursor-pointer transition-colors"
          >
            QUERO ACESSO AGORA — R$ 77,90
            <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
          </a>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-4">
          Garantia de 7 dias · Acesso Online · Pagamento seguro
        </p>
      </div>
    </section>
  );
}
